import React, { useState } from 'react';
import InvoiceTemplate from './InvoiceTemplate';
import SystemConfigForm from './SystemConfigForm';
import HolidayCalendar from './HolidayCarlender';
import DateInput from './DateInput';
import {ReactComponent as DeleteIcon} from '../../components/svgs/deleteIcon.svg'
import {ReactComponent as CalendarIcon} from '../../components/svgs/calendarStar.svg'


const SettingsTab = () => {
  const [activeTab, setActiveTab] = useState('exclusiveDays');
  const [addedDates, setAddedDates] = useState([]);

  const handleAddDate = (date) => {
    setAddedDates([...addedDates, date]);
  };

  const handleDeleteDate = (index) => {
    const newDates = addedDates.filter((_, i) => i !== index);
    setAddedDates(newDates);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="customer-details-tab">
      <div className={`tab ${activeTab === 'exclusiveDays' ? 'active' : ''}`} onClick={() => handleTabClick('exclusiveDays')}>
       Exclusive Days
      </div>
      <div className={`tab ${activeTab === 'invoiceTemplate' ? 'active' : ''}`} onClick={() => handleTabClick('invoiceTemplate')}>
        Invoice Template
      </div>
      <div className={`tab ${activeTab === 'systemConfiguration' ? 'active' : ''}`} onClick={() => handleTabClick('systemConfiguration')}>
        System Configuration
      </div>
      
    <div className='order-details-tab-divider'></div>
      <div className="tab-content invoice-tab-content">
        {activeTab === 'exclusiveDays' && (
        <div className="details-content">
           <section>
           <div className="layout">
          <div div className="flex-container flex gap-10">
          <div className="flex-item calendar-border">
            <p className='calendar-text mb-6 ml-4'>Calendar</p>
            <HolidayCalendar
              onDateClick={(title) => console.log(title)}
            />
          </div>
          <div className="flex-item">
            <p className='mb-4 date-title'>Set exclusion days</p>
            <DateInput onAddDate={handleAddDate} />
            <div className="check-input mt-10">
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <span className="checkmark"></span>
              </label>
              <span className="label-text ml-16">Closed on public holidays</span>
            </div>
            {addedDates.length > 0 && (
            <div className='mt-10'>
              <p className='exclusion-days'>Upcoming exclusion days</p>
            </div>
            )}
            <ul className='mt-10 grid-layout'>
              {addedDates.map((date, index) => (
                <li key={index} className='flex gap-4 grid-item'>
                  <CalendarIcon />
                  <span className='exclusion-date mt-2'>{date}</span>
                  <DeleteIcon onClick={() => handleDeleteDate(index)} className='ml-16 mt-2'/>
                </li>
              ))}
            </ul>
          </div>
      </div>
    </div>
            </section>
            
        </div>
          
        )}

        {activeTab === 'invoiceTemplate' && (
          <div className="activity-content">
            <section>
                <InvoiceTemplate />
            </section>
          </div>
        )}
       
       {activeTab === 'systemConfiguration' && (
          <div className="activity-content">
            <section>
            <SystemConfigForm />
            </section>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsTab;
